<template>
  <div class="auth-admin container">
    <div class="card">
      <div class="card__header">认证配置管理</div>
      <div class="card__body">
        <div class="tabs">
          <button class="btn" :class="{active: activeTab==='douyin'}" @click="activeTab='douyin'">抖音小游戏</button>
          <button class="btn" :class="{active: activeTab==='wx'}" @click="activeTab='wx'">微信小游戏</button>
          <button class="btn" :class="{active: activeTab==='hongguo'}" @click="activeTab='hongguo'">红果短剧</button>
        </div>
        <div class="api-key-bar">
          <input v-model="adminKey" placeholder="X-Api-Key" />
          <button class="btn" @click="saveAdminKey">保存Key</button>
        </div>
      </div>
    </div>

    <div v-if="activeTab==='douyin'" class="panel">
      <h2>抖音小游戏认证</h2>
      <div class="card toolbar section">
        <button class="btn" @click="fetchDouyinConfigs">刷新列表</button>
        <button class="btn primary" @click="crawlDouyin">手动抓取</button>
      </div>
      <div class="list sticky-table card section">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>名称</th>
              <th>启用</th>
              <th>有效</th>
              <th>更新时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in douyin.list" :key="item.id">
              <td>{{ item.id }}</td>
              <td>{{ item.configName }}</td>
              <td><span :class="['badge', item.isActive ? 'success' : 'warn']">{{ item.isActive ? '是' : '否' }}</span></td>
              <td>
                <span v-if="item._valid===true" class="badge success">有效</span>
                <span v-else-if="item._valid===false" class="badge warn">失效</span>
                <span v-else class="badge">检测中</span>
              </td>
              <td>{{ item.updatedTime }}</td>
              <td>
                <button class="btn" @click="activateDouyin(item.id)">激活</button>
                <button class="btn danger" @click="removeDouyin(item.id)">删除</button>
                <button class="btn ghost" @click="douyin.expandedId = douyin.expandedId === item.id ? null : item.id">详情</button>
              </td>
            </tr>
            <tr v-for="item in douyin.list" :key="'detail-'+item.id" v-if="douyin.expandedId === item.id">
              <td :colspan="5">
                <div class="details">
                  <div><b>X-Tt-Token:</b> <span class="mono">{{ item.xTtToken }}</span> <button @click="copy(item.xTtToken)">复制</button></div>
                  <div><b>Cookies:</b> <span class="mono">{{ item.cookie || item.cookies }}</span> <button @click="copy(item.cookie || item.cookies)">复制</button></div>
                  <div><b>X-Argus:</b> <span class="mono">{{ item.xArgus }}</span></div>
                  <div><b>X-Gorgon:</b> <span class="mono">{{ item.xGorgon }}</span></div>
                  <div><b>X-Helios:</b> <span class="mono">{{ item.xHelios }}</span></div>
                  <div><b>X-Ladon:</b> <span class="mono">{{ item.xLadon }}</span></div>
                  <div><b>X-Medusa:</b> <span class="mono">{{ item.xMedusa }}</span></div>
                  <div><b>User-Agent:</b> <span class="mono">{{ item.userAgent }}</span></div>
                  <div><b>DeviceId:</b> <span class="mono">{{ item.deviceId }}</span></div>
                  <div><b>IID:</b> <span class="mono">{{ item.iid }}</span></div>
                  <div><b>版本信息:</b> <span class="mono">{{ item.versionInfo }}</span></div>
                  <div><b>描述:</b> {{ item.description }}</div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <h3>从原始请求粘贴自动解析</h3>
      <div class="raw-block card section">
        <textarea v-model="douyin.raw" placeholder="将抓包里的整段请求粘贴到这里（包含 GET/POST 第一行和各请求头）"></textarea>
        <div class="actions">
          <button class="btn primary" @click="parseDouyinRaw">解析并填充</button>
          <span class="tips">支持从URL参数与请求头自动提取 X-Tt-Token、Cookie、X-Argus、X-Gorgon、X-Helios、X-Ladon、X-Medusa、User-Agent、device_id、iid 等。</span>
        </div>
      </div>

      <h3>新建/更新配置</h3>
      <form @submit.prevent="submitDouyin" class="card section">
        <div class="grid card__body">
          <label>名称<input v-model="douyin.form.configName" required></label>
          <label>X-Tt-Token<textarea v-model="douyin.form.xTtToken" required></textarea></label>
          <label>Cookie<textarea v-model="douyin.form.cookie" required></textarea></label>
          <label>X-Argus<textarea v-model="douyin.form.xArgus" required></textarea></label>
          <label>X-Gorgon<textarea v-model="douyin.form.xGorgon" required></textarea></label>
          <label>X-Helios<textarea v-model="douyin.form.xHelios" required></textarea></label>
          <label>X-Ladon<textarea v-model="douyin.form.xLadon" required></textarea></label>
          <label>X-Medusa<textarea v-model="douyin.form.xMedusa" required></textarea></label>
          <label>User-Agent<textarea v-model="douyin.form.userAgent" required></textarea></label>
          <label>DeviceId<input v-model="douyin.form.deviceId"></label>
          <label>IID<input v-model="douyin.form.iid"></label>
          <label>版本信息(JSON)<textarea v-model="douyin.form.versionInfo" placeholder="{ }"></textarea></label>
          <label>描述<input v-model="douyin.form.description"></label>
          <label>启用<select v-model="douyin.form.isActive"><option :value="true">是</option><option :value="false">否</option></select></label>
        </div>
        <div class="actions toolbar" style="padding: 0 12px 12px 12px;">
          <button class="btn primary" type="submit">提交</button>
        </div>
      </form>
      <div class="msg" v-if="douyin.msg">{{ douyin.msg }}</div>
    </div>

    <div v-if="activeTab==='wx'" class="panel">
      <h2>微信小游戏认证</h2>
      <div class="card toolbar section">
        <button class="btn" @click="fetchWxConfigs">刷新列表</button>
        <button class="btn primary" @click="crawlWx">手动抓取</button>
      </div>
      <div class="list sticky-table card section">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>名称</th>
              <th>启用</th>
              <th>有效</th>
              <th>更新时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in wx.list" :key="item.id">
              <td>{{ item.id }}</td>
              <td>{{ item.configName }}</td>
              <td><span :class="['badge', item.isActive ? 'success' : 'warn']">{{ item.isActive ? '是' : '否' }}</span></td>
              <td>
                <span v-if="item._valid===true" class="badge success">有效</span>
                <span v-else-if="item._valid===false" class="badge warn">失效</span>
                <span v-else class="badge">检测中</span>
              </td>
              <td>{{ item.updatedTime }}</td>
              <td>
                <button class="btn" @click="activateWx(item.id)">激活</button>
                <button class="btn danger" @click="removeWx(item.id)">删除</button>
                <button class="btn ghost" @click="wx.expandedId = wx.expandedId === item.id ? null : item.id">详情</button>
              </td>
            </tr>
            <tr v-for="item in wx.list" :key="'wx-detail-'+item.id" v-if="wx.expandedId === item.id">
              <td :colspan="5">
                <div class="details">
                  <div><b>buildVersion:</b> <span class="mono">{{ item.buildVersion }}</span></div>
                  <div><b>abt:</b> <span class="mono">{{ item.abt }}</span></div>
                  <div><b>uin:</b> <span class="mono">{{ item.uin }}</span></div>
                  <div><b>passTicket:</b> <span class="mono">{{ item.passTicket }}</span> <button @click="copy(item.passTicket)">复制</button></div>
                  <div><b>keyValue:</b> <span class="mono">{{ item.keyValue }}</span> <button @click="copy(item.keyValue)">复制</button></div>
                  <div><b>authSessionId:</b> <span class="mono">{{ item.authSessionId }}</span> <button @click="copy(item.authSessionId)">复制</button></div>
                  <div><b>xWechatKey:</b> <span class="mono">{{ item.xWechatKey }}</span> <button @click="copy(item.xWechatKey)">复制</button></div>
                  <div><b>xWechatUin:</b> <span class="mono">{{ item.xWechatUin }}</span></div>
                  <div><b>cookie:</b> <span class="mono">{{ item.cookie }}</span> <button @click="copy(item.cookie)">复制</button></div>
                  <div><b>exportkey:</b> <span class="mono">{{ item.exportkey }}</span></div>
                  <div><b>xWxgameSession:</b> <span class="mono">{{ item.xWxgameSession }}</span></div>
                  <div><b>描述:</b> {{ item.description }}</div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <h3>从原始请求粘贴自动解析</h3>
      <div class="raw-block card section">
        <textarea v-model="wx.raw" placeholder="将抓包里的整段请求粘贴到这里（包含 GET ... 第一行和各请求头）"></textarea>
        <div class="actions">
          <button class="btn primary" @click="parseWxRaw">解析并填充</button>
          <span class="tips">支持从URL参数与请求头自动提取 build_version、abt、uin、pass_ticket、key、auth_session_id、X-WECHAT-KEY、X-WECHAT-UIN、exportkey、x-wxgame-session、cookie 等。</span>
        </div>
      </div>

      <h3>新建/更新配置</h3>
      <form @submit.prevent="submitWx" class="card section">
        <div class="grid card__body">
          <label>名称<input v-model="wx.form.configName" required></label>
          <label>buildVersion<input v-model="wx.form.buildVersion" required></label>
          <label>abt<input v-model="wx.form.abt" required></label>
          <label>uin<input v-model="wx.form.uin" required></label>
          <label>passTicket<textarea v-model="wx.form.passTicket" required></textarea></label>
          <label>keyValue<textarea v-model="wx.form.keyValue" required></textarea></label>
          <label>authSessionId<textarea v-model="wx.form.authSessionId" required></textarea></label>
          <label>xWechatKey<textarea v-model="wx.form.xWechatKey" required></textarea></label>
          <label>xWechatUin<input v-model="wx.form.xWechatUin" required></label>
          <label>cookie<textarea v-model="wx.form.cookie" required></textarea></label>
          <label>exportkey<textarea v-model="wx.form.exportkey"></textarea></label>
          <label>xWxgameSession<input v-model="wx.form.xWxgameSession"></label>
          <label>描述<input v-model="wx.form.description"></label>
          <label>启用<select v-model="wx.form.isActive"><option :value="true">是</option><option :value="false">否</option></select></label>
        </div>
        <div class="actions toolbar" style="padding: 0 12px 12px 12px;">
          <button class="btn primary" type="submit">提交</button>
        </div>
      </form>
      <div class="msg" v-if="wx.msg">{{ wx.msg }}</div>
    </div>

    <div v-if="activeTab==='hongguo'" class="panel">
      <h2>红果短剧认证</h2>
      <div class="card toolbar section">
        <button class="btn" @click="fetchHongguoConfigs">刷新列表</button>
        <button class="btn primary" @click="crawlHongguo">手动抓取</button>
        <div style="margin-left:auto;display:flex;gap:8px;align-items:center;">
          <input type="date" v-model="hongguo.crawlDate" style="padding:6px;">
          <select v-model="hongguo.rankType" style="padding:6px;">
            <option value="all">全部榜单</option>
            <option value="hot">热播榜</option>
            <option value="rise">飙升榜</option>
            <option value="new">新剧榜</option>
            <option value="search">热搜榜</option>
          </select>
          <input type="number" min="1" max="100" v-model.number="hongguo.count" placeholder="数量" style="width:80px;padding:6px;" />
          <button class="btn" @click="crawlHongguoByDate">按日期抓取</button>
        </div>
      </div>
      <div class="list sticky-table card section">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>名称</th>
              <th>启用</th>
              <th>有效</th>
              <th>更新时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in hongguo.list" :key="item.id">
              <td>{{ item.id }}</td>
              <td>{{ item.configName }}</td>
              <td><span :class="['badge', item.isActive ? 'success' : 'warn']">{{ item.isActive ? '是' : '否' }}</span></td>
              <td>
                <span v-if="item._valid===true" class="badge success">有效</span>
                <span v-else-if="item._valid===false" class="badge warn">失效</span>
                <span v-else class="badge">检测中</span>
              </td>
              <td>{{ item.updatedTime }}</td>
              <td>
                <button class="btn" @click="activateHongguo(item.id)">激活</button>
                <button class="btn danger" @click="removeHongguo(item.id)">删除</button>
                <button class="btn ghost" @click="hongguo.expandedId = hongguo.expandedId === item.id ? null : item.id">详情</button>
              </td>
            </tr>
            <tr v-for="item in hongguo.list" :key="'hg-detail-'+item.id" v-if="hongguo.expandedId === item.id">
              <td :colspan="5">
                <div class="details">
                  <div><b>X-Tt-Token:</b> <span class="mono">{{ item.xTtToken }}</span> <button @click="copy(item.xTtToken)">复制</button></div>
                  <div><b>Cookies:</b> <span class="mono">{{ item.cookies }}</span> <button @click="copy(item.cookies)">复制</button></div>
                  <div><b>描述:</b> {{ item.description }}</div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <h3>从原始请求粘贴自动解析</h3>
      <div class="raw-block card section">
        <textarea v-model="hongguo.raw" placeholder="将抓包里的整段请求粘贴到这里（包含 GET ... 第一行和各请求头）"></textarea>
        <div class="actions">
          <button class="btn primary" @click="parseHongguoRaw">解析并填充</button>
          <span class="tips">支持自动提取 X-Tt-Token 与 Cookie 等关键认证字段。</span>
        </div>
      </div>

      <h3>新建/更新配置</h3>
      <form @submit.prevent="submitHongguo" class="card section">
        <div class="grid card__body">
          <label>名称<input v-model="hongguo.form.configName" required></label>
          <label>X-Tt-Token<textarea v-model="hongguo.form.xTtToken" required></textarea></label>
          <label>Cookies<textarea v-model="hongguo.form.cookies" required></textarea></label>
          <label>描述<input v-model="hongguo.form.description"></label>
          <label>启用<select v-model="hongguo.form.isActive"><option :value="true">是</option><option :value="false">否</option></select></label>
        </div>
        <div class="actions toolbar" style="padding: 0 12px 12px 12px;">
          <button class="btn primary" type="submit">提交</button>
        </div>
      </form>
      <div class="msg" v-if="hongguo.msg">{{ hongguo.msg }}</div>
    </div>
    <!-- Modal -->
    <div v-if="modal.show" class="modal-mask">
      <div class="modal">
        <div class="modal__header">{{ modal.title }}</div>
        <div class="modal__body">{{ modal.content }}</div>
        <div class="modal__actions">
          <button class="btn" v-if="modal.mode==='confirm'" @click="modal.show=false">取消</button>
          <button class="btn primary" @click="() => { if(modal.mode==='confirm' && modal.onConfirm){ modal.onConfirm() } modal.show=false }">{{ modal.mode==='confirm' ? '确定' : '知道了' }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const API_BASE = process.env.API_BASE || ''
export default {
  name: 'AuthAdmin',
  data () {
    return {
      activeTab: 'douyin',
      adminKey: '',
      douyin: {
        list: [],
        msg: '',
        raw: '',
        expandedId: null,
        form: {
          configName: '', xTtToken: '', cookie: '', xArgus: '', xGorgon: '', xHelios: '', xLadon: '', xMedusa: '', userAgent: '', deviceId: '', iid: '', versionInfo: '', description: '', isActive: false
        }
      },
      wx: {
        list: [],
        msg: '',
        raw: '',
        expandedId: null,
        form: {
          configName: '', buildVersion: '', abt: '', uin: '', passTicket: '', keyValue: '', authSessionId: '', wxHeader: '1', xWechatKey: '', xWechatUin: '', cookie: '', exportkey: '', xWxgameSession: '', description: '', isActive: false
        }
      },
      hongguo: {
        list: [],
        msg: '',
        raw: '',
        expandedId: null,
        form: {
          configName: '', xTtToken: '', cookies: '', description: '', isActive: false
        },
        crawlDate: '',
        rankType: 'all',
        count: 100
      },
      modal: {
        show: false,
        title: '提示',
        content: '',
        mode: 'alert', // 模式：'alert' 或 'confirm'
        onConfirm: null
      }
    }
  },
  created () {
    try { this.adminKey = localStorage.getItem('admin_api_key') || '' } catch (e) {}
    this.fetchDouyinConfigs()
    this.fetchWxConfigs()
    this.fetchHongguoConfigs()
  },
  methods: {
    async crawlDouyin () {
      try {
        const r = await fetch(API_BASE + '/api/douyin/game/crawl', { method: 'POST', headers: this.authHeaders() })
        const j = await this._parseResponse(r)
        this.alert(j.message || (j.success ? '抓取已触发' : `抓取失败: ${r.status}`))
      } catch (e) { this.alert('抓取失败: ' + e) }
    },
    async crawlWx () {
      try {
        const r = await fetch(API_BASE + '/api/wxgame/crawl', { method: 'POST', headers: this.authHeaders() })
        const j = await this._parseResponse(r)
        this.alert(j.message || (j.success ? '抓取已触发' : `抓取失败: ${r.status}`))
      } catch (e) { this.alert('抓取失败: ' + e) }
    },
    async crawlHongguo () {
      try {
        const r = await fetch(API_BASE + '/api/honguo/crawl', { method: 'POST', headers: this.authHeaders() })
        const j = await this._parseResponse(r)
        this.alert(j.message || (j.success ? '抓取已触发' : `抓取失败: ${r.status}`))
      } catch (e) { this.alert('抓取失败: ' + e) }
    },
    async crawlHongguoByDate () {
      try {
        const d = (this.hongguo.crawlDate || '').trim()
        if (!d) { this.alert('请选择日期'); return }
        const params = new URLSearchParams({ date: d, rankType: this.hongguo.rankType, count: String(this.hongguo.count || 50) })
        const r = await fetch(`${API_BASE}/api/honguo/crawl/date?${params.toString()}`, { method: 'POST', headers: this.authHeaders() })
        const j = await this._parseResponse(r)
        this.alert(j.message || (j.success ? `抓取完成（${j.dataCount||0} 条）` : `抓取失败: ${r.status}`))
      } catch (e) { this.alert('抓取失败: ' + e) }
    },
    authHeaders (extra = {}) {
      const h = { ...extra }
      const k = (this.adminKey || '').trim()
      if (k) h['X-Api-Key'] = k
      return h
    },
    saveAdminKey () {
      try { localStorage.setItem('admin_api_key', String(this.adminKey || '')) } catch (e) {}
      this.alert('已保存 API Key')
      // 立即刷新列表，验证可用性
      this.fetchDouyinConfigs(); this.fetchWxConfigs(); this.fetchHongguoConfigs()
    },
    // 抖音
    async fetchDouyinConfigs () {
      try {
        const res = await fetch(API_BASE + '/api/douyin/game/auth', { headers: this.authHeaders() })
        const data = await res.json()
        // 先设置初始状态，使用Vue.set确保响应式
        const list = (data.configs || []).map(item => {
          return { ...item, _valid: null }
        })
        this.douyin.list = list
        
        // 自动检测有效性（并发）
        await Promise.all(this.douyin.list.map(async (it, index) => {
          try {
            const r = await fetch(`${API_BASE}/api/douyin/game/auth/${it.id}/test`, { method: 'POST', headers: this.authHeaders() })
            const j = await r.json()
            // 使用isValid字段而不是success字段来判断
            this.$set(this.douyin.list[index], '_valid', j.isValid === true)
          } catch (e) { 
            this.$set(this.douyin.list[index], '_valid', false)
          }
        }))
      } catch (e) {
        this.douyin.msg = '加载失败: ' + e
      }
    },
    async submitDouyin () {
      try {
        const res = await fetch(API_BASE + '/api/douyin/game/auth', {
          method: 'POST',
          headers: this.authHeaders({ 'Content-Type': 'application/json' }),
          body: JSON.stringify(this.douyin.form)
        })
        const data = await res.json()
        this.douyin.msg = data.message || (data.success ? '成功' : '失败')
        await this.fetchDouyinConfigs()
        this.alert(this.douyin.msg)
      } catch (e) {
        this.douyin.msg = '提交失败: ' + e
        this.alert(this.douyin.msg)
      }
    },
    async activateDouyin (id) {
      await fetch(`${API_BASE}/api/douyin/game/auth/${id}/activate`, { method: 'POST', headers: this.authHeaders() })
      await this.fetchDouyinConfigs()
      this.alert('激活成功')
    },
    async testDouyin (id) {
      const r = await fetch(`${API_BASE}/api/douyin/game/auth/${id}/test`, { method: 'POST', headers: this.authHeaders() })
      const j = await r.json()
      this.douyin.msg = j.message || (j.success ? '测试成功' : '测试失败')
      this.alert(this.douyin.msg)
    },
    async removeDouyin (id) {
      this.confirm('确认删除该配置？', async () => {
        await fetch(`${API_BASE}/api/douyin/game/auth/${id}`, { method: 'DELETE', headers: this.authHeaders() })
        await this.fetchDouyinConfigs()
        this.alert('删除成功')
      })
    },

    // 从原始请求中解析抖音参数并填充表单
    parseDouyinRaw () {
      try {
        const raw = this.douyin.raw || ''
        if (!raw) return

        // 提取首行中的 URL
        const firstLine = (raw.match(/^[^\n\r]+/m) || [''])[0]
        const urlMatch = firstLine.match(/(?:GET|POST)\s+([^\s]+)\s+HTTP/i)
        const fullUrl = urlMatch ? urlMatch[1] : ''

        const params = {}
        if (fullUrl) {
          const qIndex = fullUrl.indexOf('?')
          if (qIndex >= 0) {
            const query = fullUrl.substring(qIndex + 1)
            query.split('&').forEach(kv => {
              const [k, v] = kv.split('=')
              if (k) params[decodeURIComponent(k)] = decodeURIComponent((v || '').replace(/\+/g, '%20'))
            })
          }
        }

        // 提取请求头
        const headers = {}
        raw.split(/\r?\n/).forEach(line => {
          const idx = line.indexOf(':')
          if (idx > 0) {
            const key = line.slice(0, idx).trim()
            const val = line.slice(idx + 1).trim()
            if (key && val) headers[key.toLowerCase()] = val
          }
        })

        const f = this.douyin.form
        f.xTtToken = headers['x-tt-token'] || f.xTtToken
        f.cookie = headers['cookie'] || f.cookie
        f.xArgus = headers['x-argus'] || f.xArgus
        f.xGorgon = headers['x-gorgon'] || f.xGorgon
        f.xHelios = headers['x-helios'] || f.xHelios
        f.xLadon = headers['x-ladon'] || f.xLadon
        f.xMedusa = headers['x-medusa'] || f.xMedusa
        f.userAgent = headers['user-agent'] || f.userAgent
        f.deviceId = params['device_id'] || headers['bdp-did'] || f.deviceId
        f.iid = params['iid'] || f.iid

        // 构建简化的版本信息 JSON
        const vi = {
          manifest_version_code: params['manifest_version_code'] || undefined,
          app_version: params['app_version'] || undefined,
          version_code: params['version_code'] || undefined,
          version_name: params['version_name'] || undefined,
          tma_jssdk_version: params['tma_jssdk_version'] || undefined,
          aid: params['aid'] || undefined,
          channel: params['channel'] || undefined,
          device_brand: params['device_brand'] || undefined,
          device_type: params['device_type'] || undefined,
          os_version: params['os_version'] || undefined
        }
        // 移除未定义字段并序列化
        const clean = Object.fromEntries(Object.entries(vi).filter(([_, v]) => v !== undefined))
        if (Object.keys(clean).length) f.versionInfo = JSON.stringify(clean)

        this.douyin.msg = '解析完成，已填充表单'
      } catch (e) {
        this.douyin.msg = '解析失败: ' + e
      }
    },

    // 微信
    async fetchWxConfigs () {
      try {
        const res = await fetch(API_BASE + '/api/wxgame/auth-config/list', { headers: this.authHeaders() })
        const data = await res.json()
        // 先设置初始状态，使用Vue.set确保响应式
        const list = (data.data || []).map(item => {
          return { ...item, _valid: null }
        })
        this.wx.list = list
        
        // 并发检测有效性
        await Promise.all(this.wx.list.map(async (it, index) => {
          try {
            const r = await fetch(`${API_BASE}/api/wxgame/auth-config/${it.id}/test`, { method: 'POST', headers: this.authHeaders() })
            const j = await r.json()
            // 使用isValid字段而不是success字段来判断
            this.$set(this.wx.list[index], '_valid', j.isValid === true)
          } catch (e) { 
            this.$set(this.wx.list[index], '_valid', false)
          }
        }))
      } catch (e) {
        this.wx.msg = '加载失败: ' + e
      }
    },
    async submitWx () {
      try {
        const res = await fetch(API_BASE + '/api/wxgame/auth-config/create', {
          method: 'POST',
          headers: this.authHeaders({ 'Content-Type': 'application/json' }),
          body: JSON.stringify(this.wx.form)
        })
        const data = await res.json()
        this.wx.msg = data.message || (data.success ? '成功' : '失败')
        await this.fetchWxConfigs()
        this.alert(this.wx.msg)
      } catch (e) {
        this.wx.msg = '提交失败: ' + e
        this.alert(this.wx.msg)
      }
    },
    async activateWx (id) {
      await fetch(`${API_BASE}/api/wxgame/auth-config/${id}/activate`, { method: 'POST', headers: this.authHeaders() })
      await this.fetchWxConfigs()
      this.alert('激活成功')
    },
    async testWx (id) {
      const r = await fetch(`${API_BASE}/api/wxgame/auth-config/${id}/test`, { method: 'POST', headers: this.authHeaders() })
      const j = await r.json()
      this.wx.msg = j.message || (j.success ? '测试成功' : '测试失败')
      this.alert(this.wx.msg)
    },
    async removeWx (id) {
      this.confirm('确认删除该配置？', async () => {
        await fetch(`${API_BASE}/api/wxgame/auth-config/${id}`, { method: 'DELETE', headers: this.authHeaders() })
        await this.fetchWxConfigs()
        this.alert('删除成功')
      })
    },

    // 从原始请求中解析微信参数并填充表单
    parseWxRaw () {
      try {
        const raw = this.wx.raw || ''
        if (!raw) return

        // 尝试从第一行（GET 之后）提取 URL
        const firstLine = (raw.match(/^[^\n\r]+/m) || [''])[0]
        const urlMatch = firstLine.match(/GET\s+([^\s]+)\s+HTTP/i)
        const fullUrl = urlMatch ? urlMatch[1] : ''

        const params = {}
        if (fullUrl) {
          const qIndex = fullUrl.indexOf('?')
          if (qIndex >= 0) {
            const query = fullUrl.substring(qIndex + 1)
            query.split('&').forEach(kv => {
              const [k, v] = kv.split('=')
              if (k) params[decodeURIComponent(k)] = decodeURIComponent((v || '').replace(/\+/g, '%20'))
            })
          }
        }

        // 将请求头提取为简单的 key: value 对
        const headers = {}
        raw.split(/\r?\n/).forEach(line => {
          const idx = line.indexOf(':')
          if (idx > 0) {
            const key = line.slice(0, idx).trim()
            const val = line.slice(idx + 1).trim()
            if (key && val) headers[key.toLowerCase()] = val
          }
        })

        // 映射到表单字段
        const f = this.wx.form
        f.buildVersion = params['build_version'] || f.buildVersion
        f.abt = params['abt'] || f.abt
        f.uin = params['uin'] || headers['x-wechat-uin'] || f.uin
        f.passTicket = params['pass_ticket'] || f.passTicket
        f.keyValue = params['key'] || headers['x-wechat-key'] || f.keyValue
        f.authSessionId = params['auth_session_id'] || (headers['cookie'] ? this._parseCookie(headers['cookie'], 'auth_session_id') : '') || f.authSessionId
        f.wxHeader = params['wx_header'] || '1'
        f.xWechatKey = headers['x-wechat-key'] || f.xWechatKey
        f.xWechatUin = headers['x-wechat-uin'] || f.xWechatUin
        f.cookie = headers['cookie'] || f.cookie
        f.exportkey = params['exportkey'] || headers['exportkey'] || f.exportkey
        f.xWxgameSession = params['x-wxgame-session'] || headers['x-wxgame-session'] || f.xWxgameSession

        this.wx.msg = '解析完成，已填充表单'
      } catch (e) {
        this.wx.msg = '解析失败: ' + e
      }
    },
    _parseCookie (cookieStr, name) {
      try {
        const parts = cookieStr.split(';')
        for (let p of parts) {
          const [k, v] = p.split('=')
          if (k && k.trim() === name) return decodeURIComponent((v || '').trim())
        }
      } catch (e) {}
      return ''
    },

    // 红果短剧
    async fetchHongguoConfigs () {
      try {
        const res = await fetch(API_BASE + '/api/hongguo/auth-config', { headers: this.authHeaders() })
        const data = await res.json()
        // 先设置初始状态，使用Vue.set确保响应式
        const list = (data.data || []).map(item => {
          return { ...item, _valid: null }
        })
        this.hongguo.list = list
        
        // 并发检测有效性
        await Promise.all(this.hongguo.list.map(async (it, index) => {
          try {
            const r = await fetch(`${API_BASE}/api/hongguo/auth-config/${it.id}/test`, { method: 'POST', headers: this.authHeaders() })
            const j = await r.json()
            // 使用isValid字段而不是success字段来判断
            this.$set(this.hongguo.list[index], '_valid', j.isValid === true)
          } catch (e) { 
            this.$set(this.hongguo.list[index], '_valid', false)
          }
        }))
      } catch (e) {
        this.hongguo.msg = '加载失败: ' + e
      }
    },
    async submitHongguo () {
      try {
        const res = await fetch(API_BASE + '/api/hongguo/auth-config', {
          method: 'POST',
          headers: this.authHeaders({ 'Content-Type': 'application/json' }),
          body: JSON.stringify(this.hongguo.form)
        })
        const data = await res.json()
        this.hongguo.msg = data.message || (data.success ? '成功' : '失败')
        await this.fetchHongguoConfigs()
        this.alert(this.hongguo.msg)
      } catch (e) {
        this.hongguo.msg = '提交失败: ' + e
        this.alert(this.hongguo.msg)
      }
    },
    async activateHongguo (id) {
      await fetch(`${API_BASE}/api/hongguo/auth-config/${id}/activate`, { method: 'POST', headers: this.authHeaders() })
      await this.fetchHongguoConfigs()
      this.alert('激活成功')
    },
    async testHongguo (id) {
      const r = await fetch(`${API_BASE}/api/hongguo/auth-config/${id}/test`, { method: 'POST', headers: this.authHeaders() })
      const j = await r.json()
      this.hongguo.msg = j.message || (j.success ? '测试成功' : '测试失败')
      this.alert(this.hongguo.msg)
    },
    async removeHongguo (id) {
      this.confirm('确认删除该配置？', async () => {
        await fetch(`${API_BASE}/api/hongguo/auth-config/${id}`, { method: 'DELETE', headers: this.authHeaders() })
        await this.fetchHongguoConfigs()
        this.alert('删除成功')
      })
    },

    // 从原始请求中解析红果参数并填充表单
    parseHongguoRaw () {
      try {
        const raw = this.hongguo.raw || ''
        if (!raw) return

        // 提取请求头
        const headers = {}
        raw.split(/\r?\n/).forEach(line => {
          const idx = line.indexOf(':')
          if (idx > 0) {
            const key = line.slice(0, idx).trim()
            const val = line.slice(idx + 1).trim()
            if (key && val) headers[key.toLowerCase()] = val
          }
        })

        const f = this.hongguo.form
        f.xTtToken = headers['x-tt-token'] || f.xTtToken
        f.cookies = headers['cookie'] || f.cookies

        this.hongguo.msg = '解析完成，已填充表单'
      } catch (e) {
        this.hongguo.msg = '解析失败: ' + e
      }
    },

    // 工具方法
    async copy (text) {
      try {
        if (!text) return
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(String(text))
        } else {
          const ta = document.createElement('textarea')
          ta.value = String(text)
          document.body.appendChild(ta)
          ta.select()
          document.execCommand('copy')
          document.body.removeChild(ta)
        }
      } catch (e) {}
    },

    // 弹窗辅助方法
    alert (content, title = '提示') {
      this.modal.title = title
      this.modal.content = content
      this.modal.mode = 'alert'
      this.modal.onConfirm = null
      this.modal.show = true
    },
    confirm (content, onConfirm, title = '确认') {
      this.modal.title = title
      this.modal.content = content
      this.modal.mode = 'confirm'
      this.modal.onConfirm = onConfirm
      this.modal.show = true
    },
    async _parseResponse (res) {
      try {
        const ct = (res.headers.get('content-type') || '').toLowerCase()
        if (ct.includes('application/json')) {
          return await res.json()
        } else {
          const text = await res.text()
          return { success: res.ok, message: text && text.length < 500 ? text : (res.ok ? 'OK' : `HTTP ${res.status}`) }
        }
      } catch (e) {
        return { success: false, message: String(e) }
      }
    }
  }
}
</script>

<style scoped>
.auth-admin { padding: 16px; }
.tabs { margin-bottom: 12px; }
.tabs button { margin-right: 8px; padding: 6px 12px; }
.tabs button.active { background: #409eff; color: #fff; }
.grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 8px; }
.grid label { display: flex; flex-direction: column; font-size: 12px; }
.grid input, .grid textarea, .grid select { padding: 6px; }
.actions { margin: 8px 0; }
.list { overflow-x: auto; }
.list table { width: 100%; border-collapse: collapse; table-layout: fixed; }
.list th, .list td { border: 1px solid #eaeaea; padding: 6px; text-align: left; }
.msg { margin-top: 8px; color: #333; }
.raw-block { margin: 8px 0; }
.raw-block textarea { width: 100%; min-height: 140px; padding: 6px; font-family: monospace; }
.tips { margin-left: 8px; color: #666; font-size: 12px; }
.mono { font-family: monospace; word-break: break-all; white-space: pre-wrap; }
.details { background: #fafafa; border: 1px solid #eee; padding: 8px; }

/* Modal */
.modal-mask { position: fixed; z-index: 9999; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,.35); display: flex; align-items: center; justify-content: center; }
.modal { width: 420px; max-width: calc(100% - 32px); background: #fff; border-radius: 8px; box-shadow: 0 12px 24px rgba(0,0,0,.12); overflow: hidden; }
.modal__header { padding: 12px 16px; font-weight: 600; border-bottom: 1px solid #f0f2f5; }
.modal__body { padding: 16px; color: #333; }
.modal__actions { padding: 12px 16px; display: flex; justify-content: flex-end; gap: 8px; border-top: 1px solid #f0f2f5; }
.btn { padding: 6px 12px; border: 1px solid #d4dbe6; border-radius: 6px; background: #fff; cursor: pointer; transition: all .15s ease; }
.btn:hover { background: #f6f8fb; }
.btn.primary { background: #409eff; color: #fff; border-color: #3a8ee6; }
.btn.danger { background: #f56c6c; color: #fff; border-color: #e45656; }
.btn.ghost { background: transparent; }
.container { max-width: 1080px; margin: 0 auto; padding: 12px; }
.card { background: #fff; border: 1px solid #e6ebf1; border-radius: 8px; box-shadow: 0 1px 2px rgba(0,0,0,.03); }
.card__header { padding: 12px 16px; border-bottom: 1px solid #f0f2f5; font-weight: 600; }
.card__body { padding: 12px 16px; }
.toolbar { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.badge { display: inline-block; padding: 2px 6px; border-radius: 999px; font-size: 12px; line-height: 16px; }
.badge.success { background: #e8f7ee; color: #1f8a53; }
.badge.warn { background: #fff7e6; color: #a15f00; }
.sticky-table { overflow: auto; }
.sticky-table table { border-collapse: collapse; width: 100%; table-layout: fixed; }
.sticky-table th, .sticky-table td { border: 1px solid #eef2f7; padding: 8px; }
.sticky-table thead th { position: sticky; top: 0; background: #fbfcfe; z-index: 1; }
</style>


// WEBPACK FOOTER //
// src/components/AuthAdmin.vue